import React, { Component, Fragment } from "react";
import { curdActions } from "../../reduxCURD/actions.js";
import _ from "lodash";
import ThisTable from "../Common/ThisTable/index.jsx";
import { languageService } from "../../Language/language.service.js";
import { pencilSquare } from "react-icons-kit/fa/pencilSquare";
import SvgIcon from "react-icons-kit";
import { ToastService } from "../../utils/toastify.js";
import { Modal } from "reactstrap";
import { MyButton } from "../Common/Forms/formsMiscItems.jsx";
import { themeService } from "../../theme/service/activeTheme.service.js";
import { CommonModalStyle } from "../../style/basic/commonControls.js";
import { ModalStyles } from "../Common/styles.js";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import { commonSummaryStyle } from "../Common/Summary/styles/CommonSummaryStyle";
import { commonPageStyle } from "../Common/Summary/styles/CommonPageStyle";
import { CRUDFunction } from "../../reduxCURD/container.js";
import { USER_LOADING_START_ACTIONS, USER_LOADING_STOP_ACTIONS } from "../User/userUtils.js";
import { getPlannedAssets } from "../../reduxRelated/actions/assetHelperAction.js";
import SpinnerLoader from "../Common/SpinnerLoader.js";
import { ButtonActionsTable } from "components/Common/Buttons";
import TooltipContainer from "../../libraries/TooltipContainer";
import { commonFilterStyles } from "../Common/Filters/styles/CommonFilterStyle";
import { PillTextButton } from "../../libraries/GeneralButtons/index.jsx";
import ConfirmationDialog from "../../libraries/ConfirmationDialog";
import { downloadCsv } from "../../utils/downloadCsv.js";
import { encodeForCSV } from "../../utils/csvFormatter.js";
import moment from "moment";

class PlannedAssets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      pageSize: 30,
      spinnerLoading: true,
      plannedAssets: [],
      confirmationDialog: null,
    };

    this.columns = [
      {
        Header: languageService("Asset Test"),
        accessor: "title",
        minWidth: 80,
      },
      {
        Header: languageService("Asset Name"),
        accessor: "asset.unitId",
      },

      { Header: languageService("Asset Type"), accessor: "asset.assetType", minWidth: 80 },

      {
        Header: languageService("Location"),
        accessor: "asset.location",
      },
      {
        Header: languageService("Start (milepost)"),
        accessor: "asset.start",
      },

      {
        Header: languageService("Actions"),
        id: "actions",
        minWidth: 50,
        filterable: false,
        accessor: (d) => {
          return (
            <div>
              <ButtonActionsTable
                handleClick={() =>
                  this.openConfirmationDialog(
                    languageService(`Confirm Disable`),
                    languageService(`Are you sure you want to disable test?`),
                    this.handleDelete,
                    "DeleteOne",
                    d,
                  )
                }
                margin="0px 10px 0px 0px"
                buttonText={languageService("Disable Test")}
              />
            </div>
          );
        },
      },
    ];
    this.pageOptions = [5, 10, 15, 20, 25, 30, 40, 50];
    this.handlePageSave = this.handlePageSave.bind(this);
    this.toggle = this.toggle.bind(this);
    this.getAssetTestsToUpdate = this.getAssetTestsToUpdate.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.exportToCsv = this.exportToCsv.bind(this);
  }

  componentDidMount() {
    this.props.getPlannedAssets();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.assetHelperActionType === "GET_PLANNED_ASSETS_REQUEST" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({
        spinnerLoading: true,
      });
    }

    if (
      this.props.assetHelperActionType === "GET_PLANNED_ASSETS_FAILURE" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({
        spinnerLoading: false,
      });
    }
    if (
      this.props.assetHelperActionType === "GET_PLANNED_ASSETS_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({
        plannedAssets: this.props.plannedAssets,
        spinnerLoading: false,
      });
    }

    if (this.props.assetTestActionType === "ASSETTEST_UPDATE_SUCCESS" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({
        spinnerLoading: true,
      });
      this.props.getPlannedAssets();
    }
  }

  handlePageSave(page, pageSize) {
    this.setState({
      page: page,
      pageSize: pageSize,
    });
  }

  getAssetTestsToUpdate(assetTests) {
    return assetTests.map((d) => {
      return { _id: d._id, disabled: true };
    });
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handleDelete(action, d) {
    const key = {
      DeleteOne: () => this.props.updateAssetTest(this.getAssetTestsToUpdate([d]), "disableMulti"),
      DeleteAll: () => this.props.updateAssetTest(this.getAssetTestsToUpdate(d), "disableMulti"),
    };

    key[action]();

    this.closeConfirmationDialog();
  }

  openConfirmationDialog(title, message, confirmCallback, action, data) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
          additionalInfo={data}
        />
      ),
    });
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }

  exportToCsv() {
    const { plannedAssets } = this.state;
    const formattedData = plannedAssets.map((plannedAsset) => ({
      "Asset Test": encodeForCSV(plannedAsset.title),
      "Asset Name": plannedAsset.asset && encodeForCSV(plannedAsset.asset.unitId),
      "Asset Type": plannedAsset.asset && encodeForCSV(plannedAsset.asset.assetType),
      Location: plannedAsset.asset && encodeForCSV(plannedAsset.asset.location),
      "Start (milepost)": plannedAsset.asset && encodeForCSV(plannedAsset.asset.start),
    }));

    // Using the provided downloadCsv function
    downloadCsv(formattedData, document, `leftoverAssets_${moment(new Date()).format("YYYY-MM-DD")}`, "assets");
  }

  render() {
    let pageOptions = null;
    pageOptions = this.pageOptions.map((option) => {
      return (
        <DropdownItem
          onClick={(e) => {
            this.handlePageSave(0, option);
          }}
          key={option}
          style={themeService(commonFilterStyles.pageSizeStyle)}
        >
          {option}
        </DropdownItem>
      );
    });
    return (
      <React.Fragment>
        {this.state.confirmationDialog}
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />

        <Col className="mainContent" md="12">
          <Row>
            <Col md="12">
              <div style={{ ...themeService(commonPageStyle.commonSummaryHeadingContainer), display: "inline-block" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h4 style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService("Leftover Assets")}</h4>
                  <PillTextButton
                    title={languageService("Export to CSV")}
                    onClick={this.exportToCsv}
                    style={{ fontSize: "12px", width: "max-content" }}
                  />
                </div>
                <small>
                  <strong>{languageService("Note")}:</strong>{" "}
                  {languageService(
                    "Following assets have not been made part of any inspection plan and also not been removed from asset type test configurations.",
                  )}{" "}
                  {languageService('As a result, these are being marked "Missed" on all places and alert notifications.')}{" "}
                  {languageService(
                    "These assets need to be either excluded from asset type tests configurations or included in any desired inspection plan.",
                  )}{" "}
                  {languageService("Please take appropriate action.")}
                </small>
              </div>
            </Col>

            <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
          </Row>
          <Row>
            <Col md={12}>
              {this.state.plannedAssets && this.state.plannedAssets.length > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available", width: "5%" }} key="pageSize">
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} size="sm">
                      <DropdownToggle style={themeService(commonFilterStyles.pageSizeTogglerStyle)} caret>
                        {this.state.pageSize}
                      </DropdownToggle>
                      <DropdownMenu style={{ minWidth: "auto", fontSize: "12px", padding: "0px" }}>{pageOptions}</DropdownMenu>
                    </Dropdown>
                  </div>

                  <PillTextButton
                    title={languageService("Disable All Tests")}
                    onClick={() =>
                      this.openConfirmationDialog(
                        languageService(`Confirm Disable`),
                        languageService(`Are you sure you want to disable test?`),
                        this.handleDelete,
                        "DeleteAll",
                        this.state.plannedAssets,
                      )
                    }
                    style={{ fontSize: "12px", width: "125px" }}
                  />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                <ThisTable
                  tableColumns={this.columns}
                  tableData={this.state.plannedAssets}
                  pageSize={this.state.pageSize}
                  minRows={1}
                  pagination={true}
                  forDashboard={false}
                  handlePageChange={(page) => this.handlePageSave(page, this.state.pageSize)}
                  page={this.state.page}
                  height={"auto"}
                  onClickSelect
                />
              </div>
            </Col>
          </Row>
        </Col>
      </React.Fragment>
    );
  }
}

let variables = {
  assetReducer: { assets: [] },

  applicationlookupsReducer: {
    applicationlookupss: [],
  },
  assetHelperReducer: {
    plannedAssets: {},
  },
  diagnosticsReducer: {
    userLocations: [],
  },

  assetTestReducer: {
    assetTests: [],
  },
};
const updateAssetTest = curdActions.updateAssetTest;
let containerReducers = ["assetReducer", "applicationlookupsReducer", "diagnosticsReducer", "assetHelperReducer", "assetTestReducer"];

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    getPlannedAssets,
    updateAssetTest,
  },
};

let PlannedAssetsContainer = CRUDFunction(PlannedAssets, "PlannedAsset", actionOptions, variables, containerReducers, "asset");
export default PlannedAssetsContainer;



// WEBPACK FOOTER //
// ./src/components/PlannedAssets/PlannedAssets.jsx